export const STATUS_SUMMARY_UNKNOWN = 0;
export const STATUS_SUMMARY_AVAILABLE = 1;
export const STATUS_SUMMARY_NOT_SUPPORTED = 2;
export const STATUS_SUMMARY_SUPPORTED = 3;
export const STATUS_SUMMARY_IMPLEMENTED = 4;
export const STATUS_SUMMARY_TESTED_DATA = 5;
export const STATUS_SUMMARY_TESTED_BUILDER = 6;

export const METADATA_STATUSES = {
    [STATUS_SUMMARY_UNKNOWN]: {
        name: 'Unknown (U)',
        icon: 'help-circle'
    },
    [STATUS_SUMMARY_NOT_SUPPORTED]: {
        name: 'Not Supported (N)',
        icon: 'ban'
    },
    [STATUS_SUMMARY_SUPPORTED]: {
        name: 'Supported (S)',
        icon: 'ellipse'
    },
    [STATUS_SUMMARY_IMPLEMENTED]: {
        name: 'Implemented (I)',
        icon: 'code'
    },
    [STATUS_SUMMARY_TESTED_DATA]: {
        name: 'Tested-Data (D)',
        icon: 'reader'
    },
    [STATUS_SUMMARY_TESTED_BUILDER]: {
        name: 'Tested-Builder (B)',
        icon: 'barcode'
    },
    [STATUS_SUMMARY_AVAILABLE]: {
        name: 'Available (A)',
        icon: 'checkmark-circle'
    }
};
